import {
  EssentialsAnnualDescription,
  EssentialsMonthlyDescription,
  PremiumMonthlyDescription
} from 'src/containers/StripeCheckoutContainer/components/description-components'
import { isProdReactEnvironment } from '../actions/utils'

export const BillPeriod = { Monthly: 'monthly', Annually: 'yearly' }
export const PlanType = {
  Free: 'free',
  Essentials: 'essentials',
  Premium: 'premium',
  Pro: 'pro',
  Plus: 'plus',
  Standard: 'standard',
  Basic: 'basic',
  InvitationMaker: 'invitation_maker',
  partyHost: 'party_host'
}

export const STRIPE_CHECKOUT_TIMEOUT = 60 * 5 * 1000 // 5 mins in milliseconds

/**
 * only add active plan slugs here, for legacy plans, add them to legacy section in MembershipPlansConfig
 */
export const PlanSlugs = {
  Free: 'free',
  EssentialsMonthly: 'sub_new_essentials_1_month',
  EssentialsAnnually: 'sub_essentials_yearly',
  PremiumAnnually: 'sub_premium_2_yearly',
  BasicAnnually: 'sub_basic_yearly',
  InvitationMakerMonthly: 'sub_invitation_maker_monthly',
  InvitationMakerAnnually: 'sub_invitation_maker_annual',
  PartyHostMonthly: 'sub_party_host_monthly',
  PartyHostAnnually: 'sub_party_host_annual'
}

export const SubscriptionType = {
  Hobnob: 'hobnob',
  AppStore: 'app_store',
  GooglePlay: 'play_store',
  Stripe: 'stripe'
}

const UTM_INFO_STORE_KEY = 'utm_info'

export const UpgradableSubscriptionTypes = [SubscriptionType.Hobnob, SubscriptionType.Stripe]

export const PlanTier = { Legacy: -1, Free: 0, Tier1: 1, Tier2: 2, Tier3: 3, Tier4: 4, Tier5: 5 }

const legacyPlanConfigs = [
  {
    slug: 'sub_pro_1_year',
    legacySlugs: null,
    stripeId: '',
    detailDescriptionComp: null,
    checkoutInfo: null,
    trialCheckoutInfo: null,
    isBestValue: false,
    billPeriod: BillPeriod.Annually,
    planType: PlanType.Pro,
    tier: PlanTier.Legacy,
    active: false
  },
  {
    slug: 'sub_pro_1_month',
    legacySlugs: null,
    stripeId: '',
    detailDescriptionComp: null,
    checkoutInfo: null,
    trialCheckoutInfo: null,
    isBestValue: false,
    billPeriod: BillPeriod.Monthly,
    planType: PlanType.Pro,
    tier: PlanTier.Legacy,
    active: false
  },
  {
    slug: 'sub_plus_1_year',
    legacySlugs: null,
    stripeId: '',
    detailDescriptionComp: null,
    checkoutInfo: null,
    trialCheckoutInfo: null,
    isBestValue: false,
    billPeriod: BillPeriod.Annually,
    planType: PlanType.Plus,
    tier: PlanTier.Legacy,
    active: false
  },
  {
    slug: 'sub_plus_1_month',
    legacySlugs: null,
    stripeId: '',
    detailDescriptionComp: null,
    checkoutInfo: null,
    trialCheckoutInfo: null,
    isBestValue: false,
    billPeriod: BillPeriod.Monthly,
    planType: PlanType.Plus,
    tier: PlanTier.Legacy,
    active: false
  },
  {
    slug: 'sub_standard_1_year',
    legacySlugs: null,
    stripeId: '',
    detailDescriptionComp: null,
    checkoutInfo: null,
    trialCheckoutInfo: null,
    isBestValue: false,
    billPeriod: BillPeriod.Annually,
    planType: PlanType.Standard,
    tier: PlanTier.Legacy,
    active: false
  },
  {
    slug: 'sub_standard_1_month',
    legacySlugs: null,
    stripeId: '',
    detailDescriptionComp: null,
    checkoutInfo: null,
    trialCheckoutInfo: null,
    isBestValue: false,
    billPeriod: BillPeriod.Monthly,
    planType: PlanType.Standard,
    tier: PlanTier.Legacy,
    active: false
  },
  {
    slug: 'sub_basic_yearly',
    legacySlugs: null,
    stripeId: '',
    detailDescriptionComp: null,
    checkoutInfo: null,
    trialCheckoutInfo: null,
    isBestValue: false,
    billPeriod: BillPeriod.Annually,
    planType: PlanType.Basic,
    tier: PlanTier.Legacy,
    active: false
  },
  {
    slug: 'sub_premium_1_month',
    legacySlugs: null,
    stripeId: '',
    detailDescriptionComp: null,
    checkoutInfo: null,
    trialCheckoutInfo: null,
    isBestValue: false,
    billPeriod: BillPeriod.Monthly,
    planType: PlanType.Premium,
    tier: PlanTier.Tier3,
    active: false
  },
  {
    slug: 'sub_premium_1_year',
    legacySlugs: null,
    stripeId: '',
    detailDescriptionComp: null,
    checkoutInfo: null,
    trialCheckoutInfo: null,
    isBestValue: false,
    billPeriod: BillPeriod.Annually,
    planType: PlanType.Premium,
    tier: PlanTier.Tier3,
    active: false
  }
]

const newPlanConfigs = [
  {
    slug: 'sub_invitation_maker_monthly',
    legacySlugs: null,
    stripeId: '',
    detailDescriptionComp: null,
    checkoutInfo: null,
    trialCheckoutInfo: null,
    isBestValue: false,
    billPeriod: BillPeriod.Monthly,
    planType: PlanType.InvitationMaker,
    tier: PlanTier.Tier1,
    active: false
  },
  {
    slug: 'sub_invitation_maker_annual',
    legacySlugs: null,
    stripeId: '',
    detailDescriptionComp: null,
    checkoutInfo: null,
    trialCheckoutInfo: null,
    isBestValue: false,
    billPeriod: BillPeriod.Annually,
    planType: PlanType.InvitationMaker,
    tier: PlanTier.Tier1,
    active: false
  },
  {
    slug: 'sub_party_host_monthly',
    legacySlugs: null,
    stripeId: '',
    detailDescriptionComp: null,
    checkoutInfo: null,
    trialCheckoutInfo: null,
    isBestValue: false,
    billPeriod: BillPeriod.Monthly,
    planType: PlanType.partyHost,
    tier: PlanTier.Tier5,
    active: false
  },
  {
    slug: 'sub_party_host_annual',
    legacySlugs: null,
    stripeId: '',
    detailDescriptionComp: null,
    checkoutInfo: null,
    trialCheckoutInfo: null,
    isBestValue: false,
    billPeriod: BillPeriod.Annually,
    planType: PlanType.partyHost,
    tier: PlanTier.Tier5,
    active: false
  }
]

/** Stripe Checkout Configs **/
/**
 * use getCreditsConfigs() and getMembershipPlanConfigs() to get the configs
 * as this method will detect environment to provide different config
 */
const StripeProductIds = {
  EssentialsMonthly: 'prod_OMZQO99H5Rl2Ng',
  EssentialsAnnually: 'prod_OMZLWGMztlMypw',
  PremiumAnnually: 'prod_OMZGt6nPC0IfhO',
  CreditsBundle1000: 'prod_OMY7OXEVVMN5N8',
  CreditsBundle500: 'prod_OMYB3PNCs2vL8R',
  CreditsBundle400: 'prod_OMYDJbP7Vmo5eu',
  CreditsBundle300: 'prod_OMYJ50S7qiVuId',
  CreditsBundle200: 'prod_OMYkLQ8l6y0nhV',
  CreditsBundle100: 'prod_OMYnVL4kQDuF0A',
  CreditsBundle50: 'prod_OMYsdIEmIODydF',
  CreditsBundle25: 'prod_OMYwl87TCwFk5Z',
  CreditsBundle10: 'prod_OMYyS77DaHYEsv',
  CreditsBundle5: 'prod_OMZD9njU3Hb0mH'
}

const StripeProductIdsStaging = {
  EssentialsMonthly: 'prod_Nx0RmWwpbY0atm',
  EssentialsAnnually: 'prod_Nx0Z9OUp6sQtwM',
  PremiumAnnually: 'prod_Nx0cEy2OGATo69',
  CreditsBundle1000: 'prod_OFSrSnkt95k1Wk',
  CreditsBundle500: 'prod_OFSos6qe0W8Evr',
  CreditsBundle400: 'prod_OFSkA2dVtDMJLA',
  CreditsBundle300: 'prod_O0NnSUT6fKzOrm',
  CreditsBundle200: 'prod_O0NnolFfone5GX',
  CreditsBundle100: 'prod_O0Nm1IRiuVnEyK',
  CreditsBundle50: 'prod_O0NmWRMI8RsS9M',
  CreditsBundle25: 'prod_O0NlgPJIS5k7JY',
  CreditsBundle10: 'prod_O0NlrvSINeSX7P',
  CreditsBundle5: 'prod_O0NkhKGUT9JuL2'
}

const MembershipPlansConfig = [
  {
    slug: PlanSlugs.Free,
    legacySlugs: null,
    stripeId: '',
    detailDescriptionComp: null,
    checkoutInfo: null,
    trialCheckoutInfo: null,
    isBestValue: false,
    billPeriod: null,
    planType: PlanType.Free,
    tier: PlanTier.Free,
    active: false
  },
  {
    slug: PlanSlugs.EssentialsMonthly,
    legacySlugs: null,
    stripeId: StripeProductIds.EssentialsMonthly,
    detailDescriptionComp: EssentialsMonthlyDescription,
    checkoutInfo: {
      title: 'Month-to-Month',
      priceDesc: '$9.99/mo',
      checkoutURL: 'https://buy.stripe.com/00g00w701fNA4H68wJ'
    },
    trialCheckoutInfo: null,
    isBestValue: false,
    billPeriod: BillPeriod.Monthly,
    planType: PlanType.Essentials,
    tier: PlanTier.Tier1,
    active: true
  },
  {
    slug: PlanSlugs.EssentialsAnnually,
    legacySlugs: null,
    stripeId: StripeProductIds.EssentialsAnnually,
    detailDescriptionComp: EssentialsAnnualDescription,
    checkoutInfo: {
      title: 'Annual',
      priceDesc: '$1.67/mo, billed annually at $19.99/yr',
      checkoutURL: 'https://buy.stripe.com/14k9B63NP7h4b5u4gr'
    },
    trialCheckoutInfo: {
      title: 'Annual',
      priceDesc: 'Get 7 days free, then $19.99/yr',
      checkoutURL: 'https://buy.stripe.com/cN2eVq0BD0SGb5ucMY'
    },
    isBestValue: true,
    billPeriod: BillPeriod.Annually,
    planType: PlanType.Essentials,
    tier: PlanTier.Tier2,
    active: true
  },
  {
    slug: PlanSlugs.PremiumAnnually,
    legacySlugs: null,
    stripeId: StripeProductIds.PremiumAnnually,
    detailDescriptionComp: PremiumMonthlyDescription,
    checkoutInfo: {
      title: 'Annual',
      priceDesc: '$4.99/mo, billed annually at $59.99/yr',
      checkoutURL: 'https://buy.stripe.com/7sI7sYgAB58Wc9yaEN'
    },
    trialCheckoutInfo: {
      title: 'Annual',
      priceDesc: 'Get 7 days free, then $59.99/yr',
      checkoutURL: 'https://buy.stripe.com/28o7sYbgh9pc0qQ28i'
    },
    isBestValue: false,
    billPeriod: BillPeriod.Annually,
    planType: PlanType.Premium,
    tier: PlanTier.Tier3,
    active: true
  },
  // legacy plans section, please set tier to PlanTier.Legacy,
  ...legacyPlanConfigs,
  ...newPlanConfigs
]

const MembershipPlansConfigStaging = [
  {
    slug: PlanSlugs.Free,
    legacySlugs: null,
    stripeId: '',
    detailDescriptionComp: null,
    checkoutInfo: null,
    trialCheckoutInfo: null,
    isBestValue: false,
    billPeriod: null,
    planType: PlanType.Free,
    tier: PlanTier.Free,
    active: false
  },
  {
    slug: PlanSlugs.EssentialsMonthly,
    legacySlugs: null,
    stripeId: StripeProductIdsStaging.EssentialsMonthly,
    detailDescriptionComp: EssentialsMonthlyDescription,
    checkoutInfo: {
      title: 'Month-to-Month',
      priceDesc: '$9.99/mo',
      checkoutURL: 'https://buy.stripe.com/test_4gw5od7cYcVwbE4cMP'
    },
    trialCheckoutInfo: null,
    isBestValue: false,
    billPeriod: BillPeriod.Monthly,
    planType: PlanType.Essentials,
    tier: PlanTier.Tier1,
    active: true
  },
  {
    slug: PlanSlugs.EssentialsAnnually,
    legacySlugs: null,
    stripeId: StripeProductIdsStaging.EssentialsAnnually,
    detailDescriptionComp: EssentialsAnnualDescription,
    checkoutInfo: {
      title: 'Annual',
      priceDesc: '$1.67/mo, billed annually at $19.99/yr',
      checkoutURL: 'https://buy.stripe.com/test_bIYeYN0OA3kWcI83cQ'
    },
    trialCheckoutInfo: {
      title: 'Annual',
      priceDesc: 'Get 7 days free, then $19.99/yr',
      checkoutURL: 'https://buy.stripe.com/test_dR6bMB2WI2gS37y4gT'
    },
    isBestValue: true,
    billPeriod: BillPeriod.Annually,
    planType: PlanType.Essentials,
    tier: PlanTier.Tier2,
    active: true
  },
  {
    slug: PlanSlugs.PremiumAnnually,
    legacySlugs: null,
    stripeId: StripeProductIdsStaging.PremiumAnnually,
    detailDescriptionComp: PremiumMonthlyDescription,
    checkoutInfo: {
      title: 'Annual',
      priceDesc: '$4.99/mo, billed annually at $59.99/yr',
      checkoutURL: 'https://buy.stripe.com/test_4gw6sh0OA7Bc5fGdR8'
    },
    trialCheckoutInfo: {
      title: 'Annual',
      priceDesc: 'Get 7 days free, then $59.99/yr',
      checkoutURL: 'https://buy.stripe.com/test_eVaeYN7cY2gSfUkeVd'
    },
    isBestValue: false,
    billPeriod: BillPeriod.Annually,
    planType: PlanType.Premium,
    tier: PlanTier.Tier3,
    active: true
  },
  // legacy plans section, please set tier to PlanTier.Legacy,
  ...legacyPlanConfigs,
  ...newPlanConfigs
]

const CreditBundlesConfig = [
  {
    creditsNumber: 10,
    slug: 'sub_10_credits',
    priceLabel: '$0.4/Credit',
    subTotalLabel: '$3.99',
    formula: '$0.4 x 10',
    stripeId: StripeProductIds.CreditsBundle10,
    checkoutURL: 'https://buy.stripe.com/00g4gMgABfNA5La28u'
  },
  {
    creditsNumber: 25,
    slug: 'sub_25_credits',
    priceLabel: '$0.37/Credit',
    subTotalLabel: '$9.29',
    formula: '$0.37 x 25',
    stripeId: StripeProductIds.CreditsBundle25,
    checkoutURL: 'https://buy.stripe.com/fZe28EdopeJw8XmdRb'
  },
  {
    creditsNumber: 50,
    slug: 'sub_50_credits',
    priceLabel: '$0.35/Credit',
    subTotalLabel: '$17.49',
    formula: '$0.35 x 50',
    stripeId: StripeProductIds.CreditsBundle50,
    checkoutURL: 'https://buy.stripe.com/fZe9B61FH1WKa1qaEY'
  },
  {
    creditsNumber: 100,
    slug: 'sub_100_credits',
    priceLabel: '$0.33/Credit',
    subTotalLabel: '$32.99',
    formula: '$0.33 x 100',
    stripeId: StripeProductIds.CreditsBundle100,
    checkoutURL: 'https://buy.stripe.com/eVafZu0BDatggpO4gz'
  },
  {
    creditsNumber: 200,
    slug: 'sub_200_credits',
    priceLabel: '$0.28/Credit',
    subTotalLabel: '$55.99',
    formula: '$0.28 x 200',
    stripeId: StripeProductIds.CreditsBundle200,
    checkoutURL: 'https://buy.stripe.com/bIYcNi845eJw6Pe8wO'
  },
  {
    creditsNumber: 300,
    slug: 'sub_300_credits',
    priceLabel: '$0.24/Credit',
    subTotalLabel: '$71.99',
    formula: '$0.24 x 300',
    stripeId: StripeProductIds.CreditsBundle300,
    checkoutURL: 'https://buy.stripe.com/fZe4gMdopcBo6PecN3'
  },
  {
    creditsNumber: 400,
    slug: 'sub_400_credits',
    priceLabel: '$0.21/Credit',
    subTotalLabel: '$83.99',
    formula: '$0.21 x 400',
    stripeId: StripeProductIds.CreditsBundle400,
    checkoutURL: 'https://buy.stripe.com/fZedRm0BD58Wb5u7sI'
  },
  {
    creditsNumber: 500,
    slug: 'sub_500_credits',
    priceLabel: '$0.19/Credit',
    subTotalLabel: '$94.99',
    formula: '$0.19 x 500',
    stripeId: StripeProductIds.CreditsBundle500,
    checkoutURL: 'https://buy.stripe.com/fZedRm0BDgRE7TicN1'
  },
  {
    creditsNumber: 1000,
    slug: 'sub_1000_credits',
    priceLabel: '$0.12/Credit',
    subTotalLabel: '$118.99',
    formula: '$0.12 x 1000',
    stripeId: StripeProductIds.CreditsBundle1000,
    checkoutURL: 'https://buy.stripe.com/5kA3cI5VXdFs1uU5ky'
  }
]

const CreditBundlesConfigStaging = [
  {
    creditsNumber: 10,
    slug: 'sub_10_credits',
    priceLabel: '$0.4/Credit',
    subTotalLabel: '$3.99',
    formula: '$0.4 x 10',
    stripeId: StripeProductIdsStaging.CreditsBundle10,
    checkoutURL: 'https://buy.stripe.com/test_eVa3g5fJu5t4eQg00O'
    // checkoutURL: 'https://buy.stripe.com/test_4gwcQFeFq8Fg9vW6pf'
  },
  {
    creditsNumber: 25,
    slug: 'sub_25_credits',
    priceLabel: '$0.37/Credit',
    subTotalLabel: '$9.29',
    formula: '$0.37 x 25',
    stripeId: StripeProductIdsStaging.CreditsBundle25,
    checkoutURL: 'https://buy.stripe.com/test_7sIdUJfJu4p08rS4h3'
  },
  {
    creditsNumber: 50,
    slug: 'sub_50_credits',
    priceLabel: '$0.35/Credit',
    subTotalLabel: '$17.49',
    formula: '$0.35 x 50',
    stripeId: StripeProductIdsStaging.CreditsBundle50,
    checkoutURL: 'https://buy.stripe.com/test_fZeaIx40M3kWaA08xi'
  },
  {
    creditsNumber: 100,
    slug: 'sub_100_credits',
    priceLabel: '$0.33/Credit',
    subTotalLabel: '$32.99',
    formula: '$0.33 x 100',
    stripeId: StripeProductIdsStaging.CreditsBundle100,
    checkoutURL: 'https://buy.stripe.com/test_fZebMB68U08KgYo00L'
  },
  {
    creditsNumber: 200,
    slug: 'sub_200_credits',
    priceLabel: '$0.28/Credit',
    subTotalLabel: '$55.99',
    formula: '$0.28 x 200',
    stripeId: StripeProductIdsStaging.CreditsBundle200,
    checkoutURL: 'https://buy.stripe.com/test_3cs8Ap0OA7BcfUkcNw'
  },
  {
    creditsNumber: 300,
    slug: 'sub_300_credits',
    priceLabel: '$0.24/Credit',
    subTotalLabel: '$71.99',
    formula: '$0.24 x 300',
    stripeId: StripeProductIdsStaging.CreditsBundle300,
    checkoutURL: 'https://buy.stripe.com/test_dR67wl8h2g7I0ZqbJr'
  },
  {
    creditsNumber: 400,
    slug: 'sub_400_credits',
    priceLabel: '$0.21/Credit',
    subTotalLabel: '$83.99',
    formula: '$0.21 x 400',
    stripeId: StripeProductIdsStaging.CreditsBundle400,
    checkoutURL: 'https://buy.stripe.com/test_eVa4k92WI2gScI8cNu'
  },
  {
    creditsNumber: 500,
    slug: 'sub_500_credits',
    priceLabel: '$0.19/Credit',
    subTotalLabel: '$94.99',
    formula: '$0.19 x 500',
    stripeId: StripeProductIdsStaging.CreditsBundle500,
    checkoutURL: 'https://buy.stripe.com/test_3csdUJeFqg7I0Zq5l1'
  },
  {
    creditsNumber: 1000,
    slug: 'sub_1000_credits',
    priceLabel: '$0.12/Credit',
    subTotalLabel: '$118.99',
    formula: '$0.12 x 1000',
    stripeId: StripeProductIdsStaging.CreditsBundle1000,
    checkoutURL: 'https://buy.stripe.com/test_fZe5odgNy2gS4bC7t8'
  }
]
/** Stripe Checkout Configs **/

export const getActivePlans = () => {
  return getMembershipPlanConfigs().filter(p => p.active)
}

export const getPlanBySlug = slug => {
  return getMembershipPlanConfigs().find(p => {
    if (p.slug === slug) {
      return true
    } else {
      return p.legacySlugs && p.legacySlugs.includes(slug)
    }
  })
}

export const getPlanTypeBySlug = slug => {
  const found = getPlanBySlug(slug)
  if (found) {
    return found.planType
  } else {
    return null
  }
}

export const getCheckoutInfoByFreeTrail = (plan, isFreeTrailUsed) => {
  return !isFreeTrailUsed && plan.trialCheckoutInfo ? plan.trialCheckoutInfo : plan.checkoutInfo
}

export const buildCheckoutURLForPlans = (plan, isFreeTrailUsed, userId, utmCode) => {
  const checkoutInfo = getCheckoutInfoByFreeTrail(plan, isFreeTrailUsed)
  return `${checkoutInfo.checkoutURL}?client_reference_id=${userId}&utm_source=web&utm_content=${utmCode}`
}

export const buildCheckoutURLForCreditsBundle = (plan, userId, utmCode) => {
  return `${plan.checkoutURL}?client_reference_id=${userId}&utm_source=web&utm_content=${utmCode}`
}

export const storeUTMDataByKey = (subscription, key) => {
  const data = {
    planSlug: subscription.plan?.slug,
    credits: subscription.available_credit
  }
  const utmData = {}
  utmData[key] = data
  persistUTMData(utmData)
}

export const getUTMDataByKey = key => {
  const utmData = getPersistedUTMData()
  if (utmData) {
    return utmData[key]
  } else {
    return null
  }
}

export const clearUTMData = () => {
  window.localStorage.removeItem(UTM_INFO_STORE_KEY)
}

const getPersistedUTMData = () => {
  try {
    return JSON.parse(window.localStorage.getItem(UTM_INFO_STORE_KEY))
  } catch (e) {
    console.warn('failed to get UTM info', e)
    return null
  }
}

const persistUTMData = data => {
  try {
    window.localStorage.setItem(UTM_INFO_STORE_KEY, JSON.stringify(data))
  } catch (e) {
    console.warn('failed to store UTM info', e)
  }
}

export const getMembershipPlanConfigs = () => {
  if (isProdReactEnvironment()) {
    return MembershipPlansConfig
  } else {
    return MembershipPlansConfigStaging
  }
}

export const getCreditsConfigs = () => {
  if (isProdReactEnvironment()) {
    return CreditBundlesConfig
  } else {
    return CreditBundlesConfigStaging
  }
}
